'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _history = require('../history');

var _history2 = _interopRequireDefault(_history);

var _StaticRouter = require('react-router/StaticRouter');

var _StaticRouter2 = _interopRequireDefault(_StaticRouter);

var _reducer = require('./reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DispatchingRouter = function (_Component) {
  (0, _inherits3['default'])(DispatchingRouter, _Component);

  function DispatchingRouter(props) {
    (0, _classCallCheck3['default'])(this, DispatchingRouter);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (DispatchingRouter.__proto__ || (0, _getPrototypeOf2['default'])(DispatchingRouter)).call(this, props));

    _this.handleLocationChange = function (_ref) {
      var store = _ref.store,
          action = _ref.action,
          location = _ref.location;

      store.dispatch({
        type: _reducer.LOCATION_CHANGE,
        payload: { action: action, location: location }
      });
    };

    _this.handleLocationChange(_this.props);
    return _this;
  }

  (0, _createClass3['default'])(DispatchingRouter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.handleLocationChange(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          history = _props.history,
          action = _props.action,
          location = _props.location,
          basename = _props.basename,
          props = (0, _objectWithoutProperties3['default'])(_props, ['history', 'action', 'location', 'basename']);

      return _react2['default'].createElement(_StaticRouter2['default'], (0, _extends3['default'])({
        action: action,
        location: location,
        basename: basename,
        onPush: history.push,
        onReplace: history.replace,
        blockTransitions: history.block
      }, props));
    }
  }]);
  return DispatchingRouter;
}(_react.Component);

DispatchingRouter.propTypes = {
  store: _react.PropTypes.object,
  history: _react.PropTypes.object,
  action: _react.PropTypes.string,
  location: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
  basename: _react.PropTypes.string
};

var ConnectedRouter = function (_Component2) {
  (0, _inherits3['default'])(ConnectedRouter, _Component2);

  function ConnectedRouter() {
    (0, _classCallCheck3['default'])(this, ConnectedRouter);
    return (0, _possibleConstructorReturn3['default'])(this, (ConnectedRouter.__proto__ || (0, _getPrototypeOf2['default'])(ConnectedRouter)).apply(this, arguments));
  }

  (0, _createClass3['default'])(ConnectedRouter, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          History = _props2.history,
          basename = _props2.basename,
          keyLength = _props2.keyLength,
          props = (0, _objectWithoutProperties3['default'])(_props2, ['history', 'basename', 'keyLength']);

      return _react2['default'].createElement(
        History,
        { basename: basename, keyLength: keyLength },
        function (_ref2) {
          var history = _ref2.history,
              action = _ref2.action,
              location = _ref2.location;

          return _react2['default'].createElement(DispatchingRouter, (0, _extends3['default'])({
            store: _this3.context.store || _this3.props.store,
            history: history,
            action: action,
            location: location,
            basename: basename
          }, props));
        }
      );
    }
  }]);
  return ConnectedRouter;
}(_react.Component);

ConnectedRouter.propTypes = {
  store: _react.PropTypes.object,
  history: _react.PropTypes.func,
  basename: _react.PropTypes.string,
  keyLength: _react.PropTypes.number
};
ConnectedRouter.contextTypes = {
  store: _react.PropTypes.object
};
ConnectedRouter.defaultProps = {
  history: _history2['default']
};
exports['default'] = ConnectedRouter;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/react-router-redux/ConnectedRouter.jsx
// module id = 775
// module chunks = 0